<template>
  <div
    v-if="offlineScenarios && offlineScenarios?.length > 0"
    class="mb-5"
    data-cy="offline-scenarios-container"
  >
    <h2 data-cy="offline-scenarios-header">Unsaved Offline Scenarios</h2>
    <data-table
      data-cy="offline-scenarios-table"
      :value="offlineScenarios || []"
      :rows-per-page-options="[5, 10, 20, 100]"
      paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      responsive-layout="scroll"
      current-page-report-template="Showing {first} to {last} of {totalRecords}"
    >
      <template #empty>
        <p class="text-center" data-cy="no-scenarios-found">
          No scenarios found.
        </p>
      </template>
      <column field="title" header="Name" :sortable="true">
        <template #body="{ data }">
          <router-link
            :to="{
              name: 'Scenario',
              params: { sizingId: data.sizing_id, scenarioId: data.id }
            }"
            data-cy="scenario-name-link"
          >
            {{ data.title || "Untitled" }}
          </router-link>
        </template>
      </column>
      <column
        v-if="!hideWell"
        field="sizing.well.well_name"
        header="Well"
        :sortable="true"
      >
        <template #body="{ data }">
          <router-link
            v-if="data.sizing.well?.id"
            :to="{
              name: 'Well',
              params: { well: data.sizing.well.id }
            }"
          >
            {{ data.sizing.well.well_name }}
          </router-link>
        </template>
      </column>
      <column
        field="sizing.customer.customer_name"
        header="Customer"
        :sortable="true"
      />
      <column
        v-if="!hideOwner"
        field="author.display_name"
        header="Owner"
        :sortable="false"
      />
      <column field="sizing" header="Sizing">
        <template #body="{ data }">
          <router-link
            :to="{
              name: 'Sizing',
              params: { sizingId: data.sizing?.id }
            }"
            >{{ data.sizing.title }}
          </router-link>
        </template>
      </column>
      <column field="journal_updated_at" header="Last Updated" :sortable="true">
        <template #body="{ data }">
          {{ new Date(data.journal_updated_at).toLocaleDateString() }}
        </template>
      </column>
    </data-table>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useScenariosQuery } from "gql/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

defineProps({
  hideOwner: {
    type: Boolean,
    default: false
  },
  hideWell: {
    type: Boolean,
    default: false
  }
});

const { data } = useScenariosQuery({
  variables: {
    withAggregate: false,
    where: {
      title: { _eq: "_offline_" }
    }
  }
});

const offlineScenarios = computed(() => data.value?.scenarios ?? []);
</script>
